import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY } from "@/lib/config";

const NAV = [
    { id: "services", label: "Services" },
    { id: "realisations", label: "Réalisations" },
    { id: "apropos", label: "À propos" },
    { id: "expertise", label: "Expertise" },
    { id: "formations", label: "Formations" },
    { id: "temoignages", label: "Témoignages" },
    { id: "contact", label: "Contact" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const goTo = (id) => {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            // Not on landing page — navigate to home with anchor
            window.location.href = `/#${id}`;
        }
        setOpen(false);
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-cream/80 border-b border-border/70"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
                <button
                    onClick={() => goTo("hero")}
                    data-testid="header-logo"
                    className="flex items-center gap-3 group"
                >
                    <span className="w-9 h-9 rounded-sm bg-brand text-cream font-heading text-lg font-semibold flex items-center justify-center tracking-tight">
                        A
                    </span>
                    <span className="hidden sm:flex flex-col items-start leading-tight">
                        <span className="font-heading text-base font-semibold tracking-tight text-ink">
                            {COMPANY.name}
                        </span>
                        <span className="label-overline text-stone2">Diagnostic · Bâti ancien</span>
                    </span>
                </button>

                <nav className="hidden md:flex items-center gap-8">
                    {NAV.map((n) => (
                        <button
                            key={n.id}
                            onClick={() => goTo(n.id)}
                            data-testid={`nav-${n.id}`}
                            className="text-sm font-medium text-ink/80 hover:text-brand transition-colors"
                        >
                            {n.label}
                        </button>
                    ))}
                    <button
                        onClick={() => goTo("contact")}
                        data-testid="nav-cta-devis"
                        className="ml-2 px-5 py-2.5 bg-brand hover:bg-brand-hover text-cream text-sm font-medium rounded-sm transition-colors"
                    >
                        Demander un devis
                    </button>
                </nav>

                <button
                    className="md:hidden p-2 text-ink"
                    onClick={() => setOpen(!open)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden bg-cream border-t border-border" data-testid="mobile-menu">
                    <div className="flex flex-col px-6 py-4 gap-1">
                        {NAV.map((n) => (
                            <button
                                key={n.id}
                                onClick={() => goTo(n.id)}
                                data-testid={`mobile-nav-${n.id}`}
                                className="text-left py-3 text-base font-medium text-ink/90 hover:text-brand border-b border-border/50"
                            >
                                {n.label}
                            </button>
                        ))}
                        <button
                            onClick={() => goTo("contact")}
                            data-testid="mobile-nav-cta"
                            className="mt-3 px-5 py-3 bg-brand text-cream rounded-sm font-medium"
                        >
                            Demander un devis
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
